import React from 'react';
import { Switch, Redirect, useRouteMatch } from 'react-router-dom';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { PAGE_NAMES, MISCELLANEOUS_RESOURCES, ACTION } from 'constant';
import DpdpaDataAccess from './DpdpaDataAccess';

const DpdpaDataAccessDashboard: React.FC = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.dpdpaDataAccess}
				configActionName={ACTION.searchDpdpaUser}
				exact
				path={path}
				component={DpdpaDataAccess}
			/>
			<Redirect to={path} />
		</Switch>
	);
};

export default DpdpaDataAccessDashboard;
